import moment from "moment";

const tableServiceRequests = {
  data: [],
  pagination: {},
  params: {
    observation: null,
    paginate: false,
    perPage: 100,
    page: 1,
    close: false,
    rejected: false,
    dateRange: [
      moment()
        .subtract(2, "months")
        .startOf("month")
        .format("YYYY-MM-DD"),
      moment().format("YYYY-MM-DD")
    ],
    service_requests_types_id: null,
    service_requests_state_id: null
  },
  loader: false
};

export const defaultSelectedServiceRequest = () => {
  return {
    document_id: "",
    data: null,
    historyStates: [],
    observation: "",
    stateSelectedUpdate: null,
    loader: false,
    product_id: null,
    products: []
  };
};

export default {
  transfer_ch_cr: null,
  transfer_ch_pro: null,
  serviceRequestsStates: [],
  tableServiceRequests,
  selectedServiceRequest: defaultSelectedServiceRequest(),
  sellers: [],
  paramsquery: {
    query: null
  },
  contacts: [],
  contactsWarehouses: [],
  products: [],
  params: {
    address: null,
    option: []
  },
  types: [],
  document: null,
  fileName: "",
  showModalPdf: false,
  paramsProduct: {
    code_line_filter: null
  },
  rotationRefreshmentProducts: [],
  photographicEvidences: [],
  typePhotographicEvidence: [],
  typesRotationRefreshmentProducts: [],
  responseUploadFilesRequest: {},
  action: "create",
  cities: [],
  purchaseOptions: [],
  vehicleDataByPlate: null,
  listReasonsApprovals: [],
  listReasonsRejection: [],
  productsSublineScrap: [],
  productsLineBatteries: [],
  productsLineBatteriesScrap: [],
  responseCreateRequest: null,
  errorUpdateStatus: null,
  responseSelectedServiceRequest: null,
  pathsDocumentsStatus: null,
  finalizeUpdateState: null,
  typeImageCodesRequired: ["01", "02", "03", "04", "05"],
  invoicesContact: [],
  creditNoteDocuments: [],
  loadingServiceRequests: false,
  requestServiceApproveForm: {
    motive_id: "",
    product_id: "",
    observation: ""
  },
  isActionUpdateStateView: false,
  scrapReceptionProducts: [],
  batteryMaintenanceProducts: [],
  createDocumentCurrentStateError: null,
  selectedMails: [],
  fetchData: true
};



// WEBPACK FOOTER //
// ./src/modules/request-service/state.js